import { Api } from "./Api";

export default {
  get(params = "") {
    return Api.get(`/v1/connections/get` + params);
  },
  getDomainDBConnections(dmn_id) {
    return Api.post(`/v1/connections/getDomainDBConnections?domain_id=${dmn_id}`);
  },
  getDomainAPIConnections(dmn_id) {
    return Api.post(`/v1/connections/getDomainAPIConnections?domain_id=${dmn_id}`);
  },
  changeMasterDomainConnectionDB(dmn_id, connection_id) {
    return Api.post(`/v1/connections/changeMasterDomainConnectionDB?domain_ids=${dmn_id}&connection_id=${connection_id}`);
  },
  changeMasterDomainConnectionAPI(dmn_id, connection_id) {
    return Api.post(`/v1/connections/changeMasterDomainConnectionAPI?domain_ids=${dmn_id}&connection_id=${connection_id}`);
  },
  delete(id) {
    return Api.delete(`/v1/connections/${id}`);
  },
  store(json) {
    return Api.post("/v1/connections", json);
  },
  update(id, json) {
    return Api.put(`/v1/connections/${id}`, json);
  },
  bindGeoConnectionsToDomain(params) {
    return Api.post(`/v1/connections/bindGeoConnectionsToDomain${params}`)
  },
  bindConnectionToDomain(params) {
    return Api.post(`/v1/connections/bindConnectionToDomain${params}`)
  },
  unBindConnectionToDomain(params) {
    return Api.post(`/v1/connections/unBindConnectionToDomain${params}`)
  }
};